import AEYLLogo from '@/assets/branding/workforce/aeyl-logo.png';

export default {
  name: 'Assistiv',
  isSAML: true,
  allowPersonalCourses: false,
  logo: AEYLLogo,
  colors: {
    // Brand colors
    brand_primary: '#48813C',
    brand_primary_hover: '#3A6A2F',
    brand_primary_highlight: '#A2D991',
    brand_primary_mid: '#5D9B4E',
    brand_primary_dark: '#25421E',
    brand_secondary: '#3E6C32',
  },
};
